import { Box, Button as MuiButton, CircularProgress as MuiCircularProgress, Stack } from '@mui/material';
import React from 'react';
import { ButtonProps, ButtonSize, ButtonVariant } from './types';

export const Button = ({
    StartIcon,
    EndIcon,
    Badge,
    label,
    loading = false,
    variant = 'contained',
    color = 'primary',
    disabled = false,
    size = 'medium',
    justifyContent = defaultJustifyContent(variant),
    sx,
    ...props
}: ButtonProps) => {
    const loaderSizes = {
        small: 16,
        medium: 20,
        large: 24,
    } satisfies Record<ButtonSize, number>;

    const buttonSize = buttonSizesProvider(size);

    return (
        <MuiButton
            size={size}
            color={color}
            variant={variant}
            disabled={loading || disabled}
            {...props}
            sx={{
                ...buttonSize,
                ...sx,
            }}
        >
            <Stack
                direction="row"
                spacing={1}
                width={1}
                alignItems="center"
                justifyContent={justifyContent}
                sx={{ visibility: loading ? 'hidden' : 'visible' }}
            >
                {StartIcon && <StartIcon size={size} />}
                {typeof label === 'string' ? <span>{label}</span> : label}
                {EndIcon && <EndIcon size={size} />}
                {Badge && React.cloneElement(Badge, { color })}
            </Stack>
            {loading && (
                <Box position="absolute" lineHeight={0}>
                    <MuiCircularProgress color="inherit" size={loaderSizes[size]} />
                </Box>
            )}
        </MuiButton>
    );
};

const defaultJustifyContent = (variant: ButtonVariant) => {
    if (variant === 'actions-menu-item') return 'flex-start';

    return 'center';
};

const buttonSizesProvider = (size: ButtonSize) => {
    switch (size) {
        case 'small':
            return {
                minHeight: '30px',
                minWidth: '30px',
            };
        case 'medium':
            return {
                minHeight: '36px',
                minWidth: '36px',
            };
        case 'large':
            return {
                minHeight: '42px',
                minWidth: '42px',
            };
        default:
            return {};
    }
};
